import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const WithdrawInvest: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width="47"
      height="45"
      viewBox="0 0 47 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="5"
        width="40"
        height="40"
        rx="20"
        fill="#F7F7F7"
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6587 19.2215C14.5409 19.7803 14.1667 20.3982 14.1667 20.8334C14.1667 21.2686 14.5409 21.8865 15.6587 22.4453C16.7267 22.9792 18.2604 23.3334 20 23.3334C21.7396 23.3334 23.2733 22.9792 24.3413 22.4453C25.4591 21.8865 25.8333 21.2686 25.8333 20.8334C25.8333 20.3982 25.4591 19.7803 24.3413 19.2215C23.2733 18.6876 21.7396 18.3334 20 18.3334C18.2604 18.3334 16.7267 18.6876 15.6587 19.2215ZM25.8333 23.5009C25.5964 23.6617 25.345 23.8069 25.0866 23.9361C23.7417 24.6084 21.9421 25.0001 20 25.0001C18.0579 25.0001 16.2583 24.6084 14.9134 23.9361C14.655 23.8069 14.4036 23.6617 14.1667 23.5009V25.0001C14.1667 25.4352 14.5409 26.0532 15.6587 26.612C16.7267 27.1459 18.2604 27.5001 20 27.5001C21.7396 27.5001 23.2733 27.1459 24.3413 26.612C25.4591 26.0532 25.8333 25.4352 25.8333 25.0001V23.5009ZM27.5 20.8334C27.5 19.4269 26.3817 18.3782 25.0866 17.7307C23.7417 17.0584 21.9421 16.6667 20 16.6667C18.0579 16.6667 16.2583 17.0584 14.9134 17.7307C13.6183 18.3782 12.5 19.4269 12.5 20.8334V29.1667C12.5 30.5732 13.6183 31.622 14.9134 32.2694C16.2583 32.9418 18.0579 33.3334 20 33.3334C21.9421 33.3334 23.7417 32.9418 25.0866 32.2694C26.3817 31.622 27.5 30.5732 27.5 29.1667V20.8334ZM25.8333 27.6676C25.5964 27.8284 25.345 27.9736 25.0866 28.1028C23.7417 28.7751 21.9421 29.1667 20 29.1667C18.0579 29.1667 16.2583 28.7751 14.9134 28.1028C14.655 27.9736 14.4036 27.8284 14.1667 27.6676V29.1667C14.1667 29.6019 14.5409 30.2199 15.6587 30.7787C16.7267 31.3126 18.2604 31.6667 20 31.6667C21.7396 31.6667 23.2733 31.3126 24.3413 30.7787C25.4591 30.2199 25.8333 29.6019 25.8333 29.1667V27.6676Z"
        fill="#F7F7F7"
      />
      <g filter="url(#filter0_b_371_3234)">
        <ellipse
          cx="33.3333"
          cy="13.3333"
          rx="13.3333"
          ry="13.3333"
          fill="#F7F7F7"
          fillOpacity="0.05"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5709 8.14024C30.8693 7.84192 31.3529 7.84192 31.6512 8.14024L34.3248 10.8139C34.6232 11.1122 34.6232 11.5958 34.3248 11.8942C34.0265 12.1925 33.5429 12.1925 33.2445 11.8942L31.1111 9.76069L28.9776 11.8942C28.6793 12.1925 28.1956 12.1925 27.8973 11.8942C27.599 11.5958 27.599 11.1122 27.8973 10.8139L30.5709 8.14024Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1111 7.9165C31.533 7.9165 31.875 8.25851 31.875 8.68039V13.2637C31.875 13.8715 32.1164 14.4544 32.5462 14.8842C32.976 15.3139 33.5589 15.5554 34.1666 15.5554H39.5139C39.9357 15.5554 40.2778 15.8974 40.2778 16.3193C40.2778 16.7412 39.9357 17.0832 39.5139 17.0832H34.1666C33.1537 17.0832 32.1822 16.6808 31.4659 15.9645C30.7496 15.2482 30.3472 14.2767 30.3472 13.2637V8.68039C30.3472 8.25851 30.6892 7.9165 31.1111 7.9165Z"
        fill="#F7F7F7"
      />
      <defs>
        <filter
          id="filter0_b_371_3234"
          x="5"
          y="-15"
          width="56.6667"
          height="56.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_371_3234"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_371_3234"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default WithdrawInvest;
